import { Button } from "../../components/ui/Button";

export const BenefitCardAbout = ({onGoToRegister}) => (<section id="BenefitCardAbout" className="bg-[#fff] py-16 px-6 mx-auto">
    <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-12">

        <div className="w-full lg:w-1/2">
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                Solicitação 100% online
            </span>

            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 leading-relaxed mb-4">
                Com o Combo de Cartões Consignados Bmg você tem o dobro de limite e o dobro do valor para sacar.
            </h2>

            <ul className="space-y-6 mb-8">
                <li className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">1</div>
                    <div className="flex flex-col">
                        <span className="text-[#37404E] font-bold">Saques de até 70% do limite</span>
                        <span className="text-[#37404E]">Receba na sua conta ou saque em dinheiro nos caixas eletrônicos da rede Cirrus 24h.</span>
                    </div>
                </li>
                <li className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">2</div>
                    <div className="flex flex-col">
                        <span className="text-[#37404E] font-bold">Faça compras online e em lojas</span>
                        <span className="text-[#37404E]">Utilize em Supermercados, padaria, serviços de streaming ou apps de delivery.</span>
                    </div>
                </li>
                <li className="flex items-center gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">3</div>
                    <div className="flex flex-col">
                        <span className="text-[#37404E] font-bold">Limite de até 2.8x do seu benefício.</span>
                        <span className="text-[#37404E]">Tenha em cada cartão com um limite de até 1.4x o seu benefício.</span>
                    </div>
                </li>
                <li className="flex items-center gap-4">
                    <div style={{width:'65px',height:'40px'}} className="flex items-center justify-center rounded-full bg-[#FA6300] text-white font-bold">4</div>
                    <div className="flex flex-col">
                        <span className="text-[#37404E] font-bold">Tenha sempre o Dobro</span>
                        <span className="text-[#37404E]">É muito mais vantajoso adquirir o Combo Cartões Bmg e aproveitar os benefícios nos dois cartões, ao selecionar ambos.</span>
                    </div>
                </li>
            </ul>


            <Button onClick={onGoToRegister}>
                Contratar agora
            </Button>
            <br />
            <p className="text-xs text-gray-600 mt-5">
                O prazo para pagamento é de até 96 parcelas mensais. Os valores abaixo são uma simulação e podem variar conforme as condições no momento da contratação.
                Exemplo de contratação com convênio INSS: valor emprestado de R$6.000,00 com taxa de 1,85% ao mês (24,60% ao ano), parcelado em 86 vezes. Valor total pago: R$13.072,00 (valor financiado + encargos e taxa), em 86x de R$152,00.
                Custo Efetivo Total (CET): 1,95% ao mês e 26,45% ao ano.
                Se houver carência para início do pagamento, durante esse período haverá incidência de juros, que serão diluídos nas parcelas futuras.
                Os valores de parcelas, limites de contratação, prazos, taxas de juros, tarifas e CET podem variar conforme o convênio e estão sujeitos a alterações sem aviso prévio.
            </p>
        </div>

        <div className="w-full lg:w-1/2 flex justify-center items-center">
            <img src="/assets/cartoes-bmg.png" className="w-full bg-[#FA6300] rounded-lg" alt="" />
        </div>
    </div>
</section>)